import IpcRouter from '@shared/ipc/IpcRouter.ts'

export type NotifyOptions = {
  checking?: boolean
  'not-available'?: boolean
  available?: boolean
  downloading?: boolean
  ready?: boolean
  installing?: boolean
}

export type CheckForUpdateMode = 'background' | 'manual-check' | 'install-cta' | 'channel-change' | 'channel-reset'

export type CheckForUpdateOptions = {
  mode: CheckForUpdateMode
  notify?: boolean | NotifyOptions
}

export interface UpdaterIpcRouterType {
  checkForUpdates: (options: CheckForUpdateOptions) => Promise<boolean>
  downloadUpdate: () => Promise<void>
  quitAndInstall: () => Promise<void>
}

class UpdaterIpcRouter extends IpcRouter<UpdaterIpcRouterType> {
  constructor() {
    super('updater', {
      checkForUpdates: true,
      downloadUpdate: true,
      quitAndInstall: true,
    })
  }
}

export default UpdaterIpcRouter
